import { ToolbarItem, UtilityButton } from '@kinesis/bungle';
import { Link } from 'react-router-dom';
import {
  StyledBreadcrumbText,
  BreadcrumbSeparator,
} from './breadcrumbs.styles';

const Segment = (props: SegmentProps) => {
  return (
    <>
      <ToolbarItem>
        <BreadcrumbSeparator>/</BreadcrumbSeparator>
      </ToolbarItem>
      <ToolbarItem>
        <UtilityButton magnitude={'medium'} as={Link} to={props.to}>
          <StyledBreadcrumbText>{props.label}</StyledBreadcrumbText>
        </UtilityButton>
      </ToolbarItem>
    </>
  );
};

export type SegmentProps = {
  to: string;
  label: string;
};

export { Segment };
